import state from "./moduleGlobalContextState";
import mutations from "./moduleGlobalContextMutation";
import actions from './moduleGlobalContextAction';
import getter from './moduleGlobalContextGetter';

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getter,
};
